import React from 'react';
import { useLogin } from '../hooks/useLogin';
import LoginForm from './LoginForm';
import AuthBrandPanel from './AuthBrandPanel';

interface LoginProps {
  onNavigateToRegister: () => void;
}

const Login: React.FC<LoginProps> = ({ onNavigateToRegister }) => {
  const { email, setEmail, password, setPassword, isLoggingIn, error, inviteToken, handleLogin } =
    useLogin();

  return (
    <main className="flex min-h-dvh flex-col items-center justify-center bg-background px-s4 py-s6 pb-[max(1.5rem,env(safe-area-inset-bottom))] sm:px-s6 md:px-s8 md:py-s10">
      <article className="flex w-full max-w-5xl flex-col overflow-hidden rounded-xl border border-subtle bg-card shadow-sm md:rounded-2xl md:shadow-md lg:flex-row">
        <section
          className="flex flex-1 flex-col justify-center p-s6 sm:p-s8 lg:p-s12"
          aria-labelledby="login-title"
        >
          <div className="mx-auto w-full max-w-sm">
            <div className="mb-s8 flex justify-center lg:hidden">
              <img
                src="/logo%20principal%20140x40.png"
                alt="Adlitics"
                className="h-8 w-auto object-contain dark:hidden"
              />
              <img
                src="/logo%20principal%20dark%20140x40.png"
                alt="Adlitics"
                className="hidden h-8 w-auto object-contain dark:block"
              />
            </div>

            <LoginForm
              email={email}
              password={password}
              isLoading={isLoggingIn}
              error={error}
              inviteToken={inviteToken}
              onEmailChange={setEmail}
              onPasswordChange={setPassword}
              onSubmit={handleLogin}
              onNavigateToRegister={onNavigateToRegister}
            />
          </div>
        </section>

        <AuthBrandPanel
          tagline="Gerencie suas negociações"
          taglineHighlight="de forma inteligente."
          description="Rastreie leads, conversas e conversões no seu CRM all-in-one."
        />
      </article>

      <footer className="mt-s6 max-w-md px-s4 text-center md:mt-s8">
        <p className="text-sm text-muted">
          Ao continuar, você concorda com nossos Termos de Serviço e Política de Privacidade.
        </p>
      </footer>
    </main>
  );
};

export default Login;
